import { render, staticRenderFns } from "./myxuanxiang.vue?vue&type=template&id=3d084ae8&scoped=true&"
import script from "./myxuanxiang.vue?vue&type=script&lang=js&"
export * from "./myxuanxiang.vue?vue&type=script&lang=js&"
import style0 from "./myxuanxiang.vue?vue&type=style&index=0&id=3d084ae8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d084ae8",
  null
  
)

export default component.exports